import { css } from "@emotion/react";
import styled from "@emotion/styled";
import PropTypes from "prop-types";
import React from "react";

import { h2 } from "~/styles/typographyStyles";
import { setSmallSpacing } from "~/styles/helpers";

const borderStyles = ({ theme, withBorder }) => {
    if (withBorder) {
        return css`
            ${setSmallSpacing(theme, "padding-bottom")};
            border-bottom: 1px solid ${theme.palette.lightBlue};
        `;
    }
};

const H2 = styled.h2`
    ${({ theme }) => setSmallSpacing(theme, "margin-bottom")};
    ${borderStyles};
    ${h2};
    color: ${({ color, theme }) =>
        color ? theme.palette[color] : theme.palette.darkBlue};
    text-align: ${({ align }) => align};
`;

const SectionHeading = ({
    color = "",
    align = "center",
    children,
    className = "",
    withBorder = false,
}) => <H2 {...{ color, align, withBorder, className }}>{children}</H2>;

SectionHeading.propTypes = {
    align: PropTypes.oneOf(["left", "center"]),
    color: PropTypes.string,
    children: PropTypes.node.isRequired,
    withBorder: PropTypes.bool,
};

export default SectionHeading;
